import { useContext } from 'react';
import { element } from '../../../core/elements';
import { PrivateBar } from '../../../primitives/shape/Bar';
import getBandwidth from '../../../primitives/shape/utils/getBandwidth';
import { XYCHART_EVENT_SOURCE } from '../../common/events/constants';
import TooltipContext from '../../common/events/context/TooltipContext';
import useEventEmitters from '../../common/events/hooks/useEventEmitters';
import usePointerEventHandlers from '../../common/events/hooks/useEventHandlers';
import { useBarData } from '../providers/data';

/** Public props */
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
export const BarTooltipOverlayElement = element(props => {
  var _tooltipData$nearestD, _tooltipData$nearestD2, _tooltipData$nearestD3;
  const {
    tooltipOpen,
    tooltipData,
    showTooltip,
    hideTooltip,
    width,
    height,
    xScale,
    yScale,
    horizontal,
    xAccessor,
    yAccessor,
    margin,
    seriesData,
    data,
    hide
  } = props;
  if (hide) return null;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: tooltipOpen && (tooltipData === null || tooltipData === void 0 ? void 0 : (_tooltipData$nearestD = tooltipData.nearestDatum) === null || _tooltipData$nearestD === void 0 ? void 0 : _tooltipData$nearestD.datum) && /*#__PURE__*/_jsx(_Fragment, {
      children: !horizontal ? /*#__PURE__*/_jsx(PrivateBar, {
        x: (xScale(xAccessor(tooltipData === null || tooltipData === void 0 ? void 0 : (_tooltipData$nearestD2 = tooltipData.nearestDatum) === null || _tooltipData$nearestD2 === void 0 ? void 0 : _tooltipData$nearestD2.datum)) || 0) - 5,
        y: 0,
        opacity: 0.5,
        fill: "var(--ds-interaction-hovered, #00000029)",
        width: getBandwidth(xScale) + 10,
        height: height
      }) : /*#__PURE__*/_jsx(PrivateBar, {
        y: (yScale(xAccessor(tooltipData === null || tooltipData === void 0 ? void 0 : (_tooltipData$nearestD3 = tooltipData.nearestDatum) === null || _tooltipData$nearestD3 === void 0 ? void 0 : _tooltipData$nearestD3.datum)) || 0) - 5,
        x: 0,
        opacity: 0.5,
        fill: "var(--ds-interaction-hovered, #00000029)",
        height: getBandwidth(yScale) + 10,
        width: width
      })
    })
  });
});
export const BarTooltipOverlayEmitterElement = element(props => {
  const {
    width,
    height,
    xScale,
    yScale,
    horizontal,
    xAccessor,
    yAccessor,
    margin,
    seriesData,
    showTooltip,
    hideTooltip,
    onClick,
    data,
    hide
  } = props;
  if (hide) return null;
  const eventEmitters = useEventEmitters({
    source: XYCHART_EVENT_SOURCE
  });
  usePointerEventHandlers({
    dataKey: 'nearest',
    onPointerMove: d => showTooltip(d),
    onPointerOut: () => hideTooltip(),
    onPointerDown: d => onClick && onClick(d),
    allowedSources: [XYCHART_EVENT_SOURCE],
    horizontal,
    width,
    margin,
    height,
    data,
    xScale,
    yScale,
    xAccessor,
    yAccessor,
    seriesData
  });
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx("rect", {
      style: {
        cursor: onClick ? 'pointer' : 'default'
      },
      width: width,
      height: height,
      fill: "transparent",
      ...eventEmitters
    })
  });
});
export function BarTooltipOverlayEmitter() {
  const {
    width,
    height,
    margin,
    xScale,
    yScale,
    xAccessor,
    yAccessor,
    seriesData,
    data
  } = useBarData();
  const {
    showTooltip,
    hideTooltip
  } = useContext(TooltipContext);
  return /*#__PURE__*/_jsx(BarTooltipOverlayEmitterElement, {
    showTooltip: showTooltip,
    hideTooltip: hideTooltip,
    width: width,
    height: height,
    xScale: xScale,
    yScale: yScale,
    xAccessor: xAccessor,
    yAccessor: yAccessor,
    data: data,
    seriesData: seriesData,
    margin: margin
  });
}
export function BarTooltipOverlay() {
  const {
    width,
    height,
    margin,
    xScale,
    yScale,
    xAccessor,
    yAccessor,
    seriesData,
    data
  } = useBarData();
  const {
    showTooltip,
    tooltipData,
    tooltipOpen,
    hideTooltip
  } = useContext(TooltipContext);
  return /*#__PURE__*/_jsx(BarTooltipOverlayElement, {
    tooltipOpen: tooltipOpen,
    showTooltip: showTooltip,
    hideTooltip: hideTooltip,
    tooltipData: tooltipData,
    width: width,
    height: height,
    xScale: xScale,
    yScale: yScale,
    xAccessor: xAccessor,
    yAccessor: yAccessor,
    data: data,
    seriesData: seriesData,
    margin: margin
  });
}